import React, { Component } from 'react';
import {Redirect,Link} from 'react-router-dom';
import $ from 'jquery';

class TransportPage extends Component {
	constructor(props) {
		super(props);
		this.state = {
			
		}
	}
	
  render() {
	
    return (
		<nav className="navbar navbar-expand-lg navbar-light bg-light nav_top">
		  <a className="navbar-brand" href="javascript:;"><i className="fa fa-cab"></i>&nbsp; Transport</a>
		  <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
			<span className="navbar-toggler-icon"></span>
		  </button>
		  <div className="collapse navbar-collapse" id="navbarSupportedContent">
			<ul className="navbar-nav mr-auto">
			  <li className="nav-item active">
				<Link to="/transport/vehicle" className="nav-link" >Vehicle</Link>
			  </li>
			  <li className="nav-item active">
				<Link to="/transport/transroute" className="nav-link" >Route</Link>
			  </li>
			  <li className="nav-item active">
				<Link to="/transport/destination" className="nav-link" >Destination</Link>
			  </li>
			  <li className="nav-item active">
				<Link to="/transport/allocate" className="nav-link" >Allocation</Link>
			  </li>
			</ul>
		  </div>
		</nav>
    )
  }
}

export default TransportPage;


// WEBPACK FOOTER //
// ./src/views/TransportPage/TransportPage.js